import dayjs from 'dayjs';

export const ParseValidDate = function (date) {
    return typeof (date) === 'undefined' || date === null ? null : dayjs(date);
}

function isValidDate(dateString) {
    const regex = /^\d{4}-\d{2}-\d{2}(.*)$/;
    return regex.test(dateString);
  }

export const ReturnFullDateTimeOrString = function (data) {
    try {        
        if (isValidDate(data)) {
            try {

                return dayjs(data).format('MM/DD/YYYY');
            }
            catch {
                return data;
            }
        }
        else {
            return data;
        }
    } catch {
        return data;
    }
}

export const IsNullOrEmpty = function (x) {
    if (IsNull(x)) return true;
    if (x === "") return true;

    return false;
};

export const IsNull = function (x) {
    if (typeof (x) === 'undefined') return true;
    if (x === null) return true;

    return false;
};

export const isValidURL = function (url) {
    try {
        return /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(url);
    } catch {
        return false;
    }
};